import PropTypes from 'prop-types';
import React from 'react';

const AleloStart = '/messages/alelo-start.png';

export const MessageStartIcon = (props) => {
  return (
    <div className="message-line" data-testid="message-start">
      <div
        className="message-receive message-receive__no-background"
        id={`msg-${props.message.id}`}
        data-aut-test="message-start-icon"
      >
        <div className="message-div">
          <img src={AleloStart} alt="Menina segurando um celular" />
        </div>
      </div>
    </div>
  );
};

MessageStartIcon.propTypes = {
  message: PropTypes.object
};
